<div class="flexi-compliance-page">
  <div class="ftpl-wizard">
    <header class="page-header">
      <button class="btn btn-link" type="button" (click)="cancel()">
        ← {{ 'FLEXI_COMPLIANCE_TEMPLATE.TITLE' | translate }}
      </button>
      <h2>{{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.TITLE' | translate }}</h2>
      <p class="subtitle">{{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.SUBTITLE' | translate }}</p>
    </header>

    <!-- Step indicator (collapses when duplicating) -->
    <div class="ftpl-wizard__steps" *ngIf="!isDuplicating">
      <div class="ftpl-wizard__step"
           [class.is-active]="step === 0" [class.is-done]="step > 0">
        <span class="num"><i class="pi pi-check" *ngIf="step > 0"></i><ng-container *ngIf="step <= 0">1</ng-container></span>
        {{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.STEP_BASICS' | translate }}
      </div>
      <div class="ftpl-wizard__step"
           [class.is-active]="step === 1" [class.is-done]="step > 1">
        <span class="num"><i class="pi pi-check" *ngIf="step > 1"></i><ng-container *ngIf="step <= 1">2</ng-container></span>
        {{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.STEP_TOPICS' | translate }}
      </div>
      <div class="ftpl-wizard__step"
           [class.is-active]="step === 2" [class.is-done]="step > 2">
        <span class="num"><i class="pi pi-check" *ngIf="step > 2"></i><ng-container *ngIf="step <= 2">3</ng-container></span>
        {{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.STEP_QUESTIONS' | translate }}
      </div>
      <div class="ftpl-wizard__step" [class.is-active]="step === 3">
        <span class="num">4</span>
        {{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.STEP_REVIEW' | translate }}
      </div>
    </div>

    <div class="alert alert-danger" *ngIf="error">{{ error }}</div>

    <!-- ===== Step 1: Basics ===== -->
    <section class="card" *ngIf="step === 0">
      <h3>{{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.STEP_BASICS' | translate }}</h3>

      <label>
        {{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.START_FROM' | translate }}
        <select [(ngModel)]="source">
          <option [ngValue]="'catalog'">
            {{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.START_FROM_CATALOG' | translate }}
          </option>
          <option [ngValue]="'blank'">
            {{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.START_FROM_BLANK' | translate }}
          </option>
          <option *ngFor="let t of existingTemplates" [ngValue]="t.id">
            {{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.START_FROM_COPY' | translate }} {{ t.name }}
          </option>
        </select>
      </label>
      <p class="muted" *ngIf="isDuplicating">
        {{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.DUPLICATE_HINT' | translate }}
      </p>
      <p class="muted" *ngIf="isBlank">
        {{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.BLANK_HINT' | translate }}
      </p>

      <label>
        {{ 'FLEXI_COMPLIANCE_TEMPLATE.EDITOR.FIELD_NAME' | translate }} *
        <input type="text" [(ngModel)]="name" maxlength="200"
               [placeholder]="'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.NAME_PLACEHOLDER' | translate" />
      </label>
      <label>
        {{ 'FLEXI_COMPLIANCE_TEMPLATE.EDITOR.FIELD_DESCRIPTION' | translate }}
        <textarea [(ngModel)]="description" rows="3" maxlength="1000"
                  [placeholder]="'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.DESC_PLACEHOLDER' | translate"></textarea>
      </label>
      <label *ngIf="!isDuplicating">
        {{ 'FLEXI_COMPLIANCE_TEMPLATE.EDITOR.FIELD_CATALOG' | translate }} *
        <select [(ngModel)]="selectedVersionId" [disabled]="versionsLoading">
          <option *ngFor="let v of versions" [ngValue]="v.id">
            {{ v.code }} — {{ v.name }}
            <ng-container *ngIf="v.isCurrent"> ({{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.CURRENT_VERSION' | translate }})</ng-container>
          </option>
        </select>
      </label>
    </section>

    <!-- ===== Step 2: Topics ===== -->
    <section class="card" *ngIf="step === 1">
      <h3>{{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.STEP_TOPICS' | translate }}</h3>
      <p class="muted">
        {{ (isBlank
             ? 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.TOPICS_HINT_BLANK'
             : 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.TOPICS_HINT') | translate }}
      </p>

      <div *ngIf="structureLoading" class="loading">
        <i class="pi pi-spin pi-spinner"></i>
      </div>

      <!-- Catalog topics (hidden in blank mode) -->
      <ng-container *ngIf="!isBlank">
        <div class="ftpl-wizard__section-card"
             *ngFor="let s of structure?.sections"
             [class.is-included]="includedSectionIds.has(s.id)"
             [class.is-excluded]="!includedSectionIds.has(s.id)"
             (click)="toggleSection(s)">
          <input type="checkbox"
                 [checked]="includedSectionIds.has(s.id)"
                 (click)="$event.stopPropagation(); toggleSection(s)" />
          <span class="title">{{ s.title }}</span>
          <span class="count-badge">
            {{ s.items.length }}
            {{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.QUESTIONS_SHORT' | translate }}
          </span>
        </div>
      </ng-container>

      <!-- Authored custom topics -->
      <div class="ftpl-wizard__section-card is-included is-custom"
           *ngFor="let t of customTopics">
        <ng-container *ngIf="renameTopicTempId !== t.tempId; else renameTopicForm">
          <i class="pi pi-star-fill custom-star"></i>
          <span class="title">{{ t.title }}</span>
          <span class="count-badge">
            {{ t.questions.length }}
            {{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.QUESTIONS_SHORT' | translate }}
          </span>
          <button class="icon-btn" type="button"
                  [attr.title]="'FLEXI_COMPLIANCE_TEMPLATE.EDITOR.RENAME_TOPIC' | translate"
                  (click)="openRenameTopic(t)">
            <i class="pi pi-pencil"></i>
          </button>
          <button class="icon-btn icon-btn--danger" type="button"
                  [attr.title]="'FLEXI_COMPLIANCE_TEMPLATE.EDITOR.REMOVE_SECTION' | translate"
                  (click)="removeCustomTopic(t.tempId)">
            <i class="pi pi-trash"></i>
          </button>
        </ng-container>
        <ng-template #renameTopicForm>
          <input type="text" class="grow" [(ngModel)]="renameTopicTitle" maxlength="300" />
          <button class="btn btn-sm btn-primary" type="button"
                  (click)="submitRenameTopic()" [disabled]="!renameTopicTitle.trim()">
            {{ 'FLEXI_COMPLIANCE_TEMPLATE.EDITOR.SAVE' | translate }}
          </button>
          <button class="btn btn-sm btn-link" type="button" (click)="cancelRenameTopic()">
            {{ 'FLEXI_COMPLIANCE_TEMPLATE.EDITOR.CANCEL' | translate }}
          </button>
        </ng-template>
      </div>

      <!-- Add custom topic -->
      <div class="ftpl-wizard__add-row">
        <button class="btn btn-link" type="button" *ngIf="!addTopicOpen" (click)="openAddTopic()">
          + {{ 'FLEXI_COMPLIANCE_TEMPLATE.EDITOR.ADD_TOPIC' | translate }}
        </button>
        <div class="inline-form" *ngIf="addTopicOpen">
          <input type="text" class="grow" [(ngModel)]="addTopicTitle" maxlength="300"
                 [placeholder]="'FLEXI_COMPLIANCE_TEMPLATE.EDITOR.TOPIC_TITLE_PLACEHOLDER' | translate" />
          <button class="btn btn-sm btn-primary" type="button"
                  (click)="submitAddTopic()" [disabled]="!addTopicTitle.trim()">
            {{ 'FLEXI_COMPLIANCE_TEMPLATE.EDITOR.SAVE' | translate }}
          </button>
          <button class="btn btn-sm btn-link" type="button" (click)="cancelAddTopic()">
            {{ 'FLEXI_COMPLIANCE_TEMPLATE.EDITOR.CANCEL' | translate }}
          </button>
        </div>
      </div>
    </section>

    <!-- ===== Step 3: Questions ===== -->
    <section class="card" *ngIf="step === 2">
      <h3>{{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.STEP_QUESTIONS' | translate }}</h3>
      <p class="muted">{{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.QUESTIONS_HINT' | translate }}</p>

      <div class="ftpl-wizard__section-tabs">
        <button type="button"
                *ngFor="let tab of topicTabs"
                [class.is-active]="activeTopicKey === tab.key"
                (click)="setActiveTopic(tab.key)">
          <i class="pi pi-star-fill" *ngIf="tab.isCustom"></i>
          {{ tab.title }}
          <span class="cnt">{{ tab.selected }}/{{ tab.total }}</span>
        </button>
      </div>

      <!-- Catalog topic: tickable catalog questions + authored ones -->
      <ng-container *ngIf="activeCatalogSection as section">
        <div class="ftpl-wizard__question-row"
             *ngFor="let item of section.items"
             [class.is-excluded]="!includedItemIds.has(item.id)"
             (click)="toggleItem(item.id)">
          <input type="checkbox"
                 [checked]="includedItemIds.has(item.id)"
                 (click)="$event.stopPropagation(); toggleItem(item.id)" />
          <div class="q">
            {{ item.question }}
            <div class="ref" *ngIf="item.regulatoryReference">{{ item.regulatoryReference }}</div>
          </div>
        </div>
        <div class="ftpl-wizard__question-row is-authored"
             *ngFor="let q of activeCustomQuestions(section.id)">
          <i class="pi pi-star-fill custom-star"></i>
          <div class="q">
            {{ q.question }}
            <div class="ref" *ngIf="q.ref">{{ q.ref }}</div>
          </div>
          <button class="icon-btn" type="button" (click)="openEditQuestion(q)">
            <i class="pi pi-pencil"></i>
          </button>
          <button class="icon-btn icon-btn--danger" type="button" (click)="removeDraftQuestion(q)">
            <i class="pi pi-trash"></i>
          </button>
        </div>
      </ng-container>

      <!-- Custom topic: authored questions only -->
      <ng-container *ngIf="activeCustomTopic as topic">
        <div class="ftpl-wizard__question-row is-authored" *ngFor="let q of topic.questions">
          <i class="pi pi-star-fill custom-star"></i>
          <div class="q">
            {{ q.question }}
            <div class="ref" *ngIf="q.ref">{{ q.ref }}</div>
          </div>
          <button class="icon-btn" type="button" (click)="openEditQuestion(q)">
            <i class="pi pi-pencil"></i>
          </button>
          <button class="icon-btn icon-btn--danger" type="button" (click)="removeDraftQuestion(q)">
            <i class="pi pi-trash"></i>
          </button>
        </div>
        <p class="muted" *ngIf="topic.questions.length === 0 && !questionFormOpen">
          {{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.EMPTY_TOPIC_HINT' | translate }}
        </p>
      </ng-container>

      <!-- Write / edit a question -->
      <div class="ftpl-wizard__add-row" *ngIf="activeTopicKey !== null">
        <button class="btn btn-link" type="button" *ngIf="!questionFormOpen" (click)="openAddQuestion()">
          + {{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.ADD_QUESTION' | translate }}
        </button>
        <div class="inline-form inline-form-custom" *ngIf="questionFormOpen">
          <textarea rows="2" [(ngModel)]="questionDraft.question" maxlength="1000"
                    [placeholder]="'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.QUESTION_PLACEHOLDER' | translate"></textarea>
          <div class="inline-form__row">
            <input type="text" class="grow" [(ngModel)]="questionDraft.ref" maxlength="500"
                   [placeholder]="'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.REF_PLACEHOLDER' | translate" />
            <input type="number" step="0.01" min="0.01" class="weight" [(ngModel)]="questionDraft.weight"
                   [placeholder]="'FLEXI_COMPLIANCE_TEMPLATE.EDITOR.ITEM_WEIGHT' | translate" />
          </div>
          <div class="inline-form__row inline-form__row--end">
            <button class="btn btn-sm btn-link" type="button" (click)="closeQuestionForm()">
              {{ 'FLEXI_COMPLIANCE_TEMPLATE.EDITOR.CANCEL' | translate }}
            </button>
            <button class="btn btn-sm btn-primary" type="button"
                    (click)="submitQuestion()" [disabled]="!questionDraft.question.trim()">
              {{ 'FLEXI_COMPLIANCE_TEMPLATE.EDITOR.SAVE' | translate }}
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Step 4: Review ===== -->
    <section class="card" *ngIf="step === 3">
      <h3>{{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.STEP_REVIEW' | translate }}</h3>

      <div class="ftpl-wizard__summary-grid">
        <div class="ftpl-wizard__summary-stat">
          <strong>{{ name }}</strong>
          <span>{{ selectedVersionCode }}</span>
        </div>
        <div class="ftpl-wizard__summary-stat">
          <strong>{{ totalTopics }}</strong>
          <span>{{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.TOPICS_INCLUDED' | translate }}</span>
        </div>
        <div class="ftpl-wizard__summary-stat">
          <strong>{{ totalSelectedQuestions }}</strong>
          <span>{{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.QUESTIONS_INCLUDED' | translate }}</span>
        </div>
      </div>

      <ng-container *ngIf="!isBlank">
        <div class="ftpl-wizard__review-section"
             *ngFor="let s of structure?.sections"
             [class.is-excluded]="!includedSectionIds.has(s.id)">
          <div class="name">{{ s.title }}</div>
          <div class="meta">
            <ng-container *ngIf="includedSectionIds.has(s.id); else excludedLabel">
              {{ selectedInSection(s) + activeCustomQuestions(s.id).length }}/{{ s.items.length + activeCustomQuestions(s.id).length }}
              {{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.QUESTIONS_SHORT' | translate }}
            </ng-container>
            <ng-template #excludedLabel>
              {{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.TOPIC_EXCLUDED' | translate }}
            </ng-template>
          </div>
        </div>
      </ng-container>

      <div class="ftpl-wizard__review-section is-custom" *ngFor="let t of customTopics">
        <div class="name">
          <i class="pi pi-star-fill custom-star"></i>
          {{ t.title }}
        </div>
        <div class="meta">
          {{ t.questions.length }}
          {{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.QUESTIONS_SHORT' | translate }}
        </div>
      </div>
    </section>

    <!-- ===== Footer navigation ===== -->
    <div class="ftpl-wizard__footer">
      <button class="btn btn-outline-secondary" type="button" (click)="cancel()" [disabled]="saving">
        {{ 'CANCEL' | translate }}
      </button>
      <div class="spacer"></div>
      <button class="btn btn-outline-secondary" type="button"
              *ngIf="step > 0" (click)="back()" [disabled]="saving">
        <i class="pi pi-arrow-left"></i>
        {{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.BACK' | translate }}
      </button>
      <button class="btn btn-primary" type="button"
              *ngIf="step < lastStep && !isDuplicating"
              (click)="next()"
              [disabled]="!canNext || structureLoading || versionsLoading">
        {{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.NEXT' | translate }}
        <i class="pi" [ngClass]="structureLoading ? 'pi-spin pi-spinner' : 'pi-arrow-right'"></i>
      </button>
      <!-- Duplicating short-circuits: name a copy, create, land in the editor -->
      <button class="btn btn-success" type="button"
              *ngIf="step === lastStep || isDuplicating"
              (click)="create()"
              [disabled]="saving || (isDuplicating && !name.trim())">
        <i class="pi" [ngClass]="saving ? 'pi-spin pi-spinner' : 'pi-check'"></i>
        {{ 'FLEXI_COMPLIANCE_TEMPLATE.WIZARD.CREATE' | translate }}
      </button>
    </div>
  </div>
</div>
